function updateCartImages() {
  fetch("/cart.js")
  .then((response) => response.json())
  .then((data) => {
    const items = data.items;
    const cartItems = document.querySelectorAll(".upcart-product-item");
    if(cartItems.length > 0) {
      items.forEach((item) => {
        if (item.properties && item.properties._customization_image) {
          const imageUrl = item.properties._customization_image;
          const cartItem = document.querySelector(`.upcart-product-item[id="${item.key}"]`);

          if (cartItem) {
            const imageContainer = cartItem.querySelector(".upcart-product-image-wrapper img");
            if (imageContainer && imageContainer.src !== imageUrl) {
              imageContainer.src = imageUrl;
            }
            imageContainer.style.opacity = 1;
          }
          
        }
      });
    }
  })
  .catch((error) => {
    console.error("Error fetch cart.js:", error);
  })
}

window.upcartOnCartOpened = () => {
  setTimeout(() => {
    updateCartImages();
  }, 1000)
  setTimeout(() => {
    updateCartImages();
  }, 2000)
}
window.upcartOnCartClosed = function () {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer && typeof cartDrawer.close === "function") {
    cartDrawer.close();
  }
};

